import logo from '../../gfx/logo-no-text.png'

export default function AppHeader() {
  return (
    <header>
      <div className="app-header-logo">
        <img src={logo} alt="Sushitime" />
      </div>
    </header>
  )
}